export default "__VITE_ASSET__BWM_Z9o8__"